export enum AppEvents {
    LOGIN = "login",
    UPDATE_MAPS_TRAFFIC_LAYER = "updateMapsTrafficLayer"
}